import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestSection() {
  const newArticles = articles.filter((a) => a.isNew);
  const recentArticles = articles.filter((a) => !a.isNew).slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-600 font-body">
              最新发布的文章与内容更新
            </p>
          </div>
          <Link
            to="/category/iconic-scenes"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-body text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            更多文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        {newArticles.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-8">
            {newArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} variant="featured" />
            ))}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {recentArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}